import { AppConfirm } from '@/components'

const INSTALL_FLAG = '__app_confirm_plugin_installed__'

const confirmPlugin = {
  install(VueApp) {
    if (VueApp[INSTALL_FLAG]) return
    VueApp[INSTALL_FLAG] = true

    let instance = null

    const mountInstance = (root) => {
      if (instance) return instance
      const ConfirmComponent = VueApp.extend(AppConfirm)
      const mountPoint = document.createElement('div')
      document.body.appendChild(mountPoint)

      const rootOptions = (root.$root || root).$options || {}

      instance = new ConfirmComponent({
        parent: root,
        store: root.$store,
        i18n: root.$i18n,
        vuetify: rootOptions.vuetify
      })

      instance.$mount(mountPoint)
      return instance
    }

    // VueApp.mixin({
    //   beforeCreate() {
    //     if (!instance && this === this.$root) {
    //       mountInstance(this)
    //     }
    //   }
    // })

    VueApp.prototype.$confirm = function confirm(options) {
      const root = this.$root || this
      const component = instance || mountInstance(root)
      if (component && typeof component.open === 'function') {
        component.open({ ...options })
      }
    }
  }
}

export default confirmPlugin
